import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Navbar from "../../nav_bar/Navbar";
import Footer from "../../footer/Footer";
import { fetchTongueTwisterById } from "./tongueTwisterService";
import "./TongueTwisterDetailPage.css";

const difficultyColor = (d) => {
  const map = { EASY: "#4caf50", MEDIUM: "#ff9800", HARD: "#e91e63" };
  return map[d?.toUpperCase()] || "#999";
};

const TongueTwisterDetailPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [item, setItem] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const load = async () => {
      setLoading(true);
      const res = await fetchTongueTwisterById(id);
      if (res.status === 200 && res.data?.status) {
        setItem(res.data.data);
      }
      setLoading(false);
    };
    load();
  }, [id]);

  if (loading) {
    return (
      <>
        <Navbar />
        <div className="ttd-page">
          <p className="ttd-loading">Loading...</p>
        </div>
        <Footer />
      </>
    );
  }

  if (!item) {
    return (
      <>
        <Navbar />
        <div className="ttd-page">
          <p className="ttd-not-found">Tongue twister not found.</p>
          <button
            className="ttd-back"
            onClick={() => navigate("/study/tongue-twisters")}
          >
            ← Back to Tongue Twisters
          </button>
        </div>
        <Footer />
      </>
    );
  }

  return (
    <>
      <Navbar />
      <div className="ttd-page">
        <button
          className="ttd-back"
          onClick={() => navigate("/study/tongue-twisters")}
        >
          ← Back to Tongue Twisters
        </button>

        {/* Hero */}
        <div className="ttd-hero">
          <div className="ttd-hero-top">
            <h1 className="ttd-title">{item.title}</h1>
            <span
              className="ttd-difficulty"
              style={{ background: difficultyColor(item.difficulty) }}
            >
              {item.difficulty}
            </span>
          </div>
        </div>

        {/* Twister Text */}
        <div className="ttd-card ttd-twister-card">
          <h3 className="ttd-card-title">🗣️ Try saying this</h3>
          <p className="ttd-twister-text">{item.description}</p>
        </div>

        {/* Pronunciation */}
        {item.pronunciation && (
          <div className="ttd-card">
            <h3 className="ttd-card-title">🔊 Pronunciation Guide</h3>
            <p className="ttd-pronunciation">{item.pronunciation}</p>
          </div>
        )}

        {/* YouTube Video */}
        {item.youtubeLink && (
          <div className="ttd-card">
            <h3 className="ttd-card-title">🎬 Video</h3>
            <div className="ttd-video-wrapper">
              <iframe
                src={item.youtubeLink
                  .replace("watch?v=", "embed/")
                  .replace("youtu.be/", "youtube.com/embed/")}
                title={item.title}
                allowFullScreen
                frameBorder="0"
              />
            </div>
          </div>
        )}

        {/* Meta */}
        {item.createdAt && (
          <p className="ttd-meta">
            Added on{" "}
            {new Date(item.createdAt).toLocaleDateString("en-IN", {
              day: "numeric",
              month: "short",
              year: "numeric",
            })}
          </p>
        )}
      </div>
      <Footer />
    </>
  );
};

export default TongueTwisterDetailPage;
